/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false,  // Change this to false if you don't want Splash screen.
};


//Home Page
const greeting = {
	title: "Abhinav Raj",
	logo_name: "AbhinavRaj",
	nickname: "abhinavraj23",
	subTitle:
		"A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
	resumeLink:
		"https://drive.google.com/file/d/1SlhcOuaHZK3ftw48y7DlWsrpRVFWcwC9/view?usp=sharing",
	// portfolio_repository: "https://github.com/ashutosh1919/masterPortfolio",
};

const socialMediaLinks = {
	/* Your Social Media Link */
	github: "https://github.com/abhinavraj23",
	linkedin: "https://www.linkedin.com/in/abhinav-raj-234497159/",
	gmail: "abhinav.23.april@gmail.com",
	// gitlab: "https://gitlab.com/ashutoshhathidara98",
	facebook: "https://www.facebook.com/abhinav.raj.583/",
	twitter: "https://twitter.com/CoderAbhinav",
	//instagram: "https://www.instagram.com/layman_brother/"
};

const skills = {
  data: [
    {
      title: "Android Development",
      fileName: "AndroidDevelopmentImg",
      skills: [
        "⚡ Designed Android interface for pocket science lab hardware using native android technologies with the USB module to perform physics and science experiments with more than 1000 PlayStore downloads",
        "⚡ Developed a cross platform application for online/offline data collection having more than 100 thousand playstore download",
        "⚡ Developed a scalable E-commerce android application using Appbase ElasticSearch client and custom elasticSearch searchBox widget to showcase elasticSearch server usage in heavy database application"
      ],
      softwareSkills: [
		{
			skillName: "Java",
			fontAwesomeClassname: "simple-icons:java",
			style: {
			  color: "#007396"
			}
		  },

        {
          skillName: "Android",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            color: "#84DE02"
          }
		},
		{
			skillName: "Dart",
			fontAwesomeClassname: "simple-icons:dart",
			style: {
			  color: "#0175C2"
			}
		  },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
			backgroundColor:"transparent",
            color: "#02569B"
          }
		},
		{
			skillName: "Firebase",
			fontAwesomeClassname: "simple-icons:firebase",
			style: {
			  backgroundColor:"transparent",
			  color: "#FFCB2B"
			}
		  },

      ]
    },
    {
      title: "Backend Development",
      fileName: "ServerClusterImg",
      skills: [
        "⚡ Developed production-level backend apis in django for an ecommerce builder tool like shopify",
        "⚡ Currently working on production-level node backend project",
        "⚡ Developed short projects in Node, Django & Flask"
      ],
      softwareSkills: [
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933"
          }
		},
		{
			skillName: "Fastify",
			fontAwesomeClassname: "simple-icons:fastify",
			style: {
			  color: "#000000"
			},
		},
        {
          skillName: "Django",
          fontAwesomeClassname: "simple-icons:django",
          style: {
			color: "#000000",
			backgroundColor: "092E20"
          }
        },
        {
          skillName: "Flask",
          fontAwesomeClassname: "simple-icons:flask",
          style: {
            color: "#000000"
          }
        },
      ]
    },
    {
      title: "Cloud Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on AWS"
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4"
          }
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900"
          }
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28"
          }
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791"
          }
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248"
          }
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6"
          }
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5"
          }
        }
      ]
    },
    // {
    //   title: "UI/UX Design",
    //   fileName: "DesignImg",
    //   skills: [
    //     "⚡ Designing highly attractive user interface for mobile and web applications",
    //     "⚡ Customizing logo designs and building logos from scratch",
    //     "⚡ Creating the flow of application functionalities to optimize user experience"
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Adobe XD",
    //       fontAwesomeClassname: "simple-icons:adobexd",
    //       style: {
    //         color: "#FF2BC2"
    //       }
    //     },
    //     {
    //       skillName: "Figma",
    //       fontAwesomeClassname: "simple-icons:figma",
    //       style: {
    //         color: "#F24E1E"
    //       }
    //     },
    //     {
    //       skillName: "Adobe Illustrator",
    //       fontAwesomeClassname: "simple-icons:adobeillustrator",
    //       style: {
    //         color: "#FF7C00"
    //       }
    //     },
    //     {
    //       skillName: "Inkscape",
    //       fontAwesomeClassname: "simple-icons:inkscape",
    //       style: {
    //         color: "#000000"
    //       }
    //     }
    //   ]
    // }
  ]
};


// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866"
      },
      profileLink: "https://www.hackerrank.com/abhinav_23_april"
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638"
      },
      profileLink: "https://www.codechef.com/users/abhinavraj23"
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB"
      },
      profileLink: "https://codeforces.com/profile/Abhinav_raj"
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754"
      },
      profileLink: "https://www.hackerearth.com/@abhinav.23.april"
    },
    // {
    //   siteName: "Kaggle",
    //   iconifyClassname: "simple-icons:kaggle",
    //   style: {
    //     color: "#20BEFF"
    //   },
    //   profileLink: "https://www.kaggle.com/laymanbrother"
    // }
  ]
}

const degrees = {
  degrees : [
    {
      title: "Dhirubhai Ambani Institute of Information and Communication Technology",
      subtitle: "B.Tech. in ICT",
      logo_path: "daiict_logo.png",
      alt_name: "DAIICT",
      duration: "2017 - Present",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, SEN, ML etc..",
        "⚡  As my extra curricular, I am the core lead of Developer Students Club and member of IEEE Student Branch."
      ],
      website_link: "https://daiict.ac.in"
    }
  ]
}

const certifications = {
	certifications: [
		{
			title: "Google Summer of Code",
			subtitle: "- Google",
			logo_path: "google_logo.png",
			certificate_link:
				"https://drive.google.com/file/d/1ktKq6T0eiIHMlYxqwvUxvJG9CP8f5_Ho/view?usp=sharing",
			alt_name: "Google",
			color_code: "#0C9D5899"
		},
		{
			title: "Google Summer of Code Mentor",
			subtitle: "- Google",
			logo_path: "google_logo.png",
			certificate_link:
				"https://drive.google.com/file/d/1peYX5hMXYsi_ieZTP346DIbRnd5zmjYU/view?usp=sharing",
			alt_name: "Google",
			color_code: "#0C9D5899"
		},
		{
			title: "Google Code-In Mentor",
			subtitle: "- Google",
			logo_path: "google_logo.png",
			certificate_link:
				"https://drive.google.com/file/d/1_n7t0EI-qk79jvkTq5Lb433qtqJ1JU1j/view?usp=sharing",
			alt_name: "Google",
			color_code: "#0C9D5899"
		},

		// {
		// 	title: "Runner's up at National Level Hackathon",
		// 	subtitle: "- Headout",
		// 	logo_path: "ibm_logo.png",
		// 	certificate_link:
		// 		"https://drive.google.com/file/d/10t_mSsVkhhySQPFPI_SEgTOg2CGEVYZ5/view?usp=sharing",
		// 	alt_name: "IBM",
		// 	color_code: "#1F70C199"
		// },

		// {
		// 	title: "Machine Learning",
		// 	subtitle: "- Andrew Ng",
		// 	logo_path: "stanford_logo.png",
		// 	certificate_link:
		// 		"",
		// 	alt_name: "Stanford University",
		// 	color_code: "#8C151599"
		// },
		// {
		// 	title: "Deep Learning",
		// 	subtitle: "- Andrew Ng",
		// 	logo_path: "deeplearning_ai_logo.png",
		// 	certificate_link:
		// 		"",
		// 	alt_name: "deeplearning.ai",
		// 	color_code: "#00000099"
		// },

		
		// {
		// 	title: "Big Data",
		// 	subtitle: "- Kim Akers",
		// 	logo_path: "microsoft_logo.png",
		// 	certificate_link:
		// 		"https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
		// 	alt_name: "Microsoft",
		// 	color_code: "#D83B0199"
		// },
		// {
		// 	title: "Advanced Data Science",
		// 	subtitle: "- Romeo Kienzler",
		// 	logo_path: "ibm_logo.png",
		// 	certificate_link:
		// 		"https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
		// 	alt_name: "IBM",
		// 	color_code: "#1F70C199"
		// },
		// {
		// 	title: "Advanced ML on GCP",
		// 	subtitle: "- GCP Training",
		// 	logo_path: "google_logo.png",
		// 	certificate_link:
		// 		"https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
		// 	alt_name: "Google",
		// 	color_code: "#0C9D5899"
		// },
		// {
		// 	title: "DL on Tensorflow",
		// 	subtitle: "- Laurence Moroney",
		// 	logo_path: "deeplearning_ai_logo.png",
		// 	certificate_link:
		// 		"https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
		// 	alt_name: "deeplearning.ai",
		// 	color_code: "#00000099"
		// },
		// {
		// 	title: "Fullstack Development",
		// 	subtitle: "- Jogesh Muppala",
		// 	logo_path: "coursera_logo.png",
		// 	certificate_link:
		// 		"https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
		// 	alt_name: "Coursera",
		// 	color_code: "#2A73CC"
		// },
		// {
		// 	title: "Kuberenetes on GCP",
		// 	subtitle: "- Qwiklabs",
		// 	logo_path: "gcp_logo.png",
		// 	certificate_link:
		// 		"https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
		// 	alt_name: "GCP",
		// 	color_code: "#4285F499"
		// },
		// {
		// 	title: "Cryptography",
		// 	subtitle: "- Saurabh Mukhopadhyay",
		// 	logo_path: "nptel_logo.png",
		// 	certificate_link:
		// 		"https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
		// 	alt_name: "NPTEL",
		// 	color_code: "#FFBB0099"
		// },
		// {
		// 	title: "Cloud Architecture",
		// 	subtitle: "- Qwiklabs",
		// 	logo_path: "gcp_logo.png",
		// 	certificate_link:
		// 		"https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
		// 	alt_name: "GCP",
		// 	color_code: "#4285F499"
		// }
	]
};


// Experience Page
const experience = {
	title: "Experience",
	subtitle: "Work, Internship and Volunteership",
	description:
		"I have worked with many evolving startups and open-source organizations as Software Developer Intern. I love software development that is why I am also involved with many personal projects.",
	header_image_path: "experience.svg",
	sections: [
		// {
		// 	title: "Work",
		// 	experiences: [
		// 		{
		// 			title: "GSoC Student (Software Developer)",
		// 			company: "FOSSASIA",
		// 			company_url: "https://fossasia.org/",
		// 			logo_path: "legato_logo.png",
		// 			duration: "June 2020 - PRESENT",
		// 			location: "Hyderabad, Telangana",
		// 			description:
		// 				"Designed Android interface for pocket science lab hardware using native android technologies with the USB module to perform physics and science experiments with more than 1000 PlayStore downloads",
		// 			color: "#0879bf",
		// 		},
		// 		{
		// 			title: "Android and ML Developer",
		// 			company: "Muffito Incorporation",
		// 			company_url: "https://www.linkedin.com/company/muffito-inc/about/",
		// 			logo_path: "muffito_logo.png",
		// 			duration: "May 2018 - Oct 2018",
		// 			location: "Pune, Maharashtra",
		// 			description:
		// 				"I have created complete Android Application for locating Pub, Bar and beverage shops around you. I have also worked on implementation of algorithms for Face Detection, Text extraction from Image. I was involved in a team for creating complete software architecure of mobile and web application as well as admin panel for company.",
		// 			color: "#9b1578",
		// 		},
		// 		{
		// 			title: "Android Developer",
		// 			company: "FreeCopy Pvt. Ltd.",
		// 			company_url: "https://www.linkedin.com/company/freecopy/about/",
		// 			logo_path: "freecopy_logo.png",
		// 			duration: "Nov 2017 - Dec 2017",
		// 			location: "Ahmedabad, Gujarat",
		// 			description:
		// 				"FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
		// 			color: "#fc1f20",
		// 		},
		// 	],
		// },
		{
			title: "Internships",
			experiences: [
				{
					title: "GSoC Student (Software Developer)",
					company: "FOSSASIA",
					company_url: "https://fossasia.org/",
					logo_path: "fossasia-logo.jpg",
					duration: "Apr 2018 - Aug 2018",
					location: "Remote",
					description:
						"Designed Android interface for pocket science lab hardware using native android technologies with the USB module to perform physics and science experiments with more than 1000 PlayStore downloads",
					color: "#0879bf",
				},
				{
					title: "Atlan",
					company: "Software Engineering Intern",
					company_url:
						"https://atlan.com/",
					logo_path: "atlan_logo.png",
					duration: "May 2019 - July 2019",
					location: "New Delhi",
					description:
						"Developed a cross platform application for online/offline data collection, which is having more than 100 thousand playstore download",
					color: "#0071C5",
				},
				{
					title: "Appbase.io",
					company: "Partime Developer",
					company_url:
						"https://appbase.io/",
					logo_path: "appbase.png",
					duration: "November 2018 - December 2019",
					location: "Remote",
					description:
						"◦ Backend Developer: Worked with the backend of Appbase which is written in Go, worked with writting tests. \n◦ ElasticSearch Client: Developed a lightweight ElasticSearch/appbase.io client library for Swift with some bulk transfer and realtime streaming functionalities. \n◦ Android Application: Developed a scalable E-commerce android application using Appbase ElasticSearch client and custom elasticSearch searchBox widget to showcase elasticSearch server usage in heavy database application",
					color: "#0071C5",
				},
				{
					title: "Lyearn",
					company: "Software Engineering Intern",
					company_url:
						"https://www.lyearn.com/",
					logo_path: "lyearn_logo.jpeg",
					duration: "August 2020 - present",
					location: "Remote",
					description:
						"◦ Backend Developer: Working with the backend as well as infrastructure for Lyearn applications",
					color: "#0071C5",
				},
			],
		},
		{
			title: "Volunteerships",
			experiences: [
				{
					title: "Google Summer of Code Mentor",
					company: "Google",
					company_url: "https://about.google/",
					logo_path: "google_logo.png",
					duration: "April 2019 - August 2020",
					location: "Remote",
					description:
						" Mentored Pocket Science lab projects for FOSSASIA in Google Summer of Code 2019",
					color: "#4285F4",
				},
				// {
				// 	title: "Microsoft Student Partner",
				// 	company: "Microsoft",
				// 	company_url: "https://www.microsoft.com/",
				// 	logo_path: "microsoft_logo.png",
				// 	duration: "Aug 2019 - May 2020",
				// 	location: "Hyderabad, Telangana",
				// 	description:
				// 		"Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
				// 	color: "#D83B01",
				// },
				// {
				// 	title: "Mozilla Campus Captain",
				// 	company: "Mozilla",
				// 	company_url: "https://www.mozilla.org/",
				// 	logo_path: "mozilla_logo.png",
				// 	duration: "Oct 2019 - May 2020",
				// 	location: "Kurnool, Andhra Pradesh",
				// 	description:
				// 		"My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
				// 	color: "#000000",
				// },
				{
					title: "Google Code-In Mentor",
					company: "Google",
					company_url: "https://about.google/",
					logo_path: "google_logo.png",
					duration: "October 2018 - December 2018",
					location: "Remote",
					description:
						" Mentored Pocket Science lab projects for FOSSASIA in Google Code-In 2019",
					color: "#4285F4",
				},
				{
					title: "Developer Students Club Lead",
					company: "DSC DA-IICT",
					company_url:
						"https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
					logo_path: "dsc_logo.png",
					duration: "Jan 2018 - May 2020",
					location: "Gandhinagar, Gujarat",
					description:
						"We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
					color: "#0C9D58",
				},
				{
					title: "Developer Program Member",
					company: "Github",
					company_url: "https://github.com/",
					logo_path: "github_logo.png",
					duration: "July 2019 - PRESENT",
					location: "Remote",
					description:
						"I am actively contributing to many opensource projects. I have contributed to projects of organisations like Mozilla, Oppia, Fossasia etc. These contributions include bug fixes and feature requests for project.",
					color: "#181717",
				},
			],
		},
	],
};

// Projects Page
const projectsHeader = {
	title: "Projects",
	description:
		"My projects makes use of vast variety of latest technology tools. My best experience is to create scalable software products and deploy them to web applications using cloud infrastructure.",
	avatar_image_path: "projects_image.svg",
};


// Contact Page
const contactPageData = {
	contactSection: {
		title: "Contact Me",
		profile_image_path: "abhinav.png",
		description:
			"I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with Android, Backend, Android, Cloud and Opensource Development.",
	},
	// blogSection: {
	// 	title: "Blogs",
	// 	subtitle:
	// 		"For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
	// 	link: "https://ashutoshhathidara.wordpress.com",
	// 	avatar_image_path: "blogs_image.svg",
	// },
	addressSection: {
		title: "Address",
		subtitle:
			"Aditya Rescidency, Opp-Sangath Platina, Motera Road, Chandkheda, Gujarat - 380005",
		avatar_image_path: "address_image.svg",
		location_map_link: "https://goo.gl/maps/2LLMayfje3SLuY1e9",
	},
	phoneSection: {
		title: "Phone Number",
		subtitle: "+91 9725705283",
	},
};

export {
	settings,
	greeting,
	socialMediaLinks,
	skills,
	competitiveSites,
	degrees,
	certifications,
	experience,
	projectsHeader,
	contactPageData,
};
